<template>
    <rkm-application>
        <template v-if="autenticado">
            <Header @toggle="handleToggle" />

            <Sidebar :open="open" />

            <rkm-main :open="open">
                <slot />
            </rkm-main>
        </template>
    </rkm-application>
</template>

<script>
// Components.
import Header from '@/Layout/Components/Header'
import Sidebar from '@/Layout/Components/Sidebar'

// Mixins.
import { repository } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: {
        Header,
        Sidebar,
    },
    computed: {
        ...mapGetters({
            autenticacao: 'getAutenticacao',
            open: 'getSidebar',
        }),
        autenticado() {
            return this.autenticacao
        },
    },
    methods: {
        ...mapActions([
            'setSidebar',
        ]),
        handleToggle() {
            this.setSidebar(!this.open)
        },
    },
    mixins: [repository],
}
</script>